    angular.module('qkr').controller('DefaultPatProductsController', defaultPatProductsController);

    defaultPatProductsController.$inject = ['$routeParams', 'defaultPatProductsService', '$location', '$anchorScroll',
        '$timeout'];

    function defaultPatProductsController($routeParams, defaultPatProductsService, $location, $anchorScroll, $timeout) {
        const vm = this;

        vm.barTabMode = $routeParams.barTab;

        vm.switchDefault = (prod) => {
            if (prod.isDefaultProduct) {
                if (vm.barTabMode && vm.defaultBarTabCount > 7) {
                    vm.showWarn = true;
                    prod.isDefaultProduct = false;
                    vm.scrollToWarn();
                    return;
                } else if (!vm.barTabMode && vm.defaultCount > 7) {
                    vm.showWarn = true;
                    prod.isDefaultProduct = false;
                    vm.scrollToWarn();
                    return;
                }
                vm.increaseCounters();
            } else if (!prod.isDefaultProduct) {
                vm.decreaseCounters();
            }
            vm.showWarn = false;

            const defaultProductUpdateCommand = {
                outletId: prod.outletId,
                menuId: prod.menuId,
                productId: prod.productId,
                isDefault: prod.isDefaultProduct
            };

            defaultPatProductsService.updateDefaultProduct(defaultProductUpdateCommand)
                .then(successResponseUpdate, handlerErrorUpdate);
        };

        vm.scrollToWarn = () => {
            $timeout(() => {
                $location.hash('warningDiv');
                $anchorScroll();
            });
        };

        vm.increaseCounters = () => {
            if (vm.barTabMode) {
                vm.defaultBarTabCount += 1;
            } else {
                vm.defaultCount += 1;
            }
        };

        vm.decreaseCounters = () => {
            if (vm.barTabMode) {
                vm.defaultBarTabCount -= 1;
            } else {
                vm.defaultCount -= 1;
            }
        };

        vm.saveRoundNumber = (prod) => {
            const defaultProductUpdateCommand = {
                outletId: prod.outletId,
                menuId: prod.menuId,
                productId: prod.productId,
                isDefault: prod.isDefaultProduct,
                groupName: prod.groupName
            };

            defaultPatProductsService.saveRoundNumber(defaultProductUpdateCommand)
                .then(successResponseUpdate, handlerErrorUpdate);
        };

        const successResponseUpdate = (data) => {
            // do not need to do anything if success
        };

        const handlerErrorUpdate = (reason) => {
            // TODO will be implemented once error handling approach in place
        };

        const successResponse = (data) => {
            vm.productList = data;
            vm.defaultCount = 0;
            angular.forEach(vm.productList, (value, key) => {
                if (value.isDefaultProduct) {
                    vm.defaultCount += 1;
                }
            });
        };

        const successResponseBarTab = (data) => {
            vm.productListBarTab = data;
            vm.defaultBarTabCount = 0;
            angular.forEach(vm.productListBarTab, (value, key) => {
                if (value.isDefaultProduct) {
                    vm.defaultBarTabCount += 1;
                }
            });
        };

        const handlerError = (reason) => {
            vm.productList = [];
        };

        const handlerErrorBarTab = (reason) => {
            vm.productListBarTab = [];
        };

        defaultPatProductsService.getProductsForDefaults($routeParams.outletId)
            .then(successResponse, handlerError);

        defaultPatProductsService.getProductsForDefaultsBarTab($routeParams.outletId)
            .then(successResponseBarTab, handlerErrorBarTab);
    }



// WEBPACK FOOTER //
// ./src/default-products/controllers/default.pat.products.controller.js